import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { PaywallLock } from '../paywall-lock'
import { LimitOverflowLock_OfferLockDataFragment } from './__generated__/limit-overflow-lock.graphql'
import { Content } from './content'
import styles from './limit-overflow-lock.module.scss'
import { ModalLock } from './modal-lock'

interface LimitOverflowLockProps {
  offerLockData: LimitOverflowLock_OfferLockDataFragment
}

export const LimitOverflowLock = ({ offerLockData }: LimitOverflowLockProps) => {
  const { componentType } = useContext(BoxLockContext)
  const content = <Content offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles.paywallCustomPlanLock}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return <ModalLock offerLockData={offerLockData}>{content}</ModalLock>
    default:
      return null
  }
}

LimitOverflowLock.fragments = {
  offerLockData: gql`
    fragment LimitOverflowLock_offerLockData on OfferLockData {
      ...LimitOverflowLockContent_offerLockData
      ...LimitOverflowLockModalLock_offerLockData
      ...PaywallLock_offerLockData
    }

    ${Content.fragments.offerLockData}
    ${ModalLock.fragments.offerLockData}
    ${PaywallLock.fragments.offerLockData}
  `,
}
